<div class="collapse-list">
  <ng-container *ngFor="let item of collapseList">
    <collapse-item
      [collapseItem]="item"
      (_onOpenItem)="handlerOnOpenItem($event)"
      (_onCloseItem)="handlerOnCloseItem($event)"
      [isHtmlEditable]="isHtmlEditable"
    >
    </collapse-item>
  </ng-container>
</div>
